import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-topo-fs",
  "use": "app-icon-topo-fs-usage",
  "viewBox": "0 0 30 27",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 27\" id=\"app-icon-topo-fs\"><path d=\"M27.187 6.403h-11.25L11.934.825a.937.937 0 00-.178-.197A2.934 2.934 0 009.956 0H2.86A2.869 2.869 0 000 2.86v21.15a2.869 2.869 0 002.86 2.812h24.327A2.869 2.869 0 0030 23.953V9.263a2.869 2.869 0 00-2.813-2.86zm0-1.875c.148.006.295.022.441.047A2.55 2.55 0 0025.162 2.7h-9.628l1.322 1.875 10.331-.047z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol